import { Icon, IconProps } from "@chakra-ui/react"

const ChatIcon = (props: IconProps) => (
  <Icon
    xmlns='http://www.w3.org/2000/svg'
    width='26px'
    height='26px'
    viewBox='0 0 26 26'
    fill='none'
    {...props}
  >
    <path
      d='M5.41667 13C6.45977 12.2177 7.75006 11.8379 9.05065 11.9303C10.3512 12.0227 11.5749 12.5812 12.4968 13.5032C13.4188 14.4251 13.9773 15.6488 14.0697 16.9494C14.1621 18.2499 13.7823 19.5402 13 20.5833M5.41667 13C4.74394 13.5045 4.19792 14.1588 3.82185 14.9109C3.44579 15.6631 3.25 16.4924 3.25 17.3333C3.24965 17.878 3.33146 18.4196 3.49267 18.9399C3.78733 19.8933 3.575 20.9549 3.38542 21.9559C3.36861 22.0415 3.37415 22.1299 3.4015 22.2127C3.42886 22.2955 3.4771 22.3699 3.54158 22.4286C3.60605 22.4873 3.68458 22.5283 3.76957 22.5478C3.85456 22.5673 3.94314 22.5646 4.02675 22.5398C4.94542 22.2885 5.85867 22.074 6.79683 22.4185C7.39573 22.6382 8.02873 22.7505 8.66667 22.75C9.50773 22.7508 10.3374 22.5554 11.0896 22.1793C11.8419 21.8032 12.496 21.2567 13 20.5833M5.41667 13C5.41667 7.92458 8.53125 3.25 14.0833 3.25C15.4732 3.24976 16.8427 3.58379 18.0764 4.22391C19.3101 4.86404 20.3717 5.79148 21.1718 6.92801C21.9718 8.06453 22.4867 9.3768 22.6732 10.7541C22.8596 12.1314 22.7121 13.5333 22.243 14.8417C21.7273 16.2782 22.2831 18.2022 22.6081 19.7903C22.627 19.8749 22.6231 19.963 22.5968 20.0455C22.5705 20.1281 22.5227 20.2022 22.4583 20.2602C22.3939 20.3182 22.3153 20.358 22.2304 20.3756C22.1455 20.3931 22.0575 20.3878 21.9754 20.3602C20.5541 19.916 18.8858 19.292 17.55 19.8553C16.1048 20.4642 14.586 20.5833 13 20.5833'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Icon>
)

export default ChatIcon
